<h2>Total Frames in this Request: ({{ frames.length }})</h2>
<div *ngFor="let frame of frames; let i = index">
  <!-- Frame image -->
  <div class="col s12 m12 l4">
    <img src="{{ frame.largeImageUrl }}" />
  </div>
  <!-- Frame details -->
  <div class="col s12 m12 l8">
    <div class="col s12 m12 l6">
      <p><strong>Brand:</strong> {{ frame.brandName }}</p>
      <p><strong>Frame:</strong> {{ frame.styleName }} ({{ frame.upc }})</p>
      <p><strong>Color:</strong> {{ frame.colorDescription }}</p>
      <p><strong>Size:</strong> {{ frame.eyeSize }}</p>
    </div>
    <div class="col s12 m12 l6">
      <p><strong>Patient Name:</strong> {{ frame.patientName }}</p>
      <p><strong>Purchase Date:</strong> {{ frame.purchaseDate }}</p>
      <p><strong>Return Reason:</strong> {{ frame.returnReason }}</p>
      <p><strong>Defect Reason:</strong> {{ frame.defectReason }}</p>
    </div>
    <div class="btn-group mt-30">
      <button class="btn btn-outline" (click)="removeFrame(i)">Remove Frame</button>
    </div>
  </div>
  <hr class="divider" />
</div>
